import { Component, OnInit, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-section-colaborador",
  templateUrl: "./section-colaborador.component.html",
  styleUrls: ["./section-colaborador.component.css"]
})
export class SectionColaboradorComponent implements OnChanges {
  @Input() public objetoColaborador: SectionColaborador = {
    nombre: "",
    numeroIdentificacion: "",
    tipoIdentificacion: "",
    fechaNacimiento: null,
    sexo: "",
    direccion: "",
    sector: "",
    cargo: "",
    barrio: ""
  };

  constructor() {}

  ngOnChanges() {
    this.getObjetoColaborador();
  }

  public async getObjetoColaborador() {
    try {
      await this.objetoColaborador;
    } catch(exception) {
      console.log(exception);
    }
  }

}

interface SectionColaborador {
  nombre: string;
  numeroIdentificacion: string;
  tipoIdentificacion: string;
  fechaNacimiento: Date;
  sexo: string;
  direccion: string;
  sector: string;
  cargo: string;
  barrio: string;
}
